import React from 'react'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import Icon from '../../shared/Icon/Icon'
import { useTheme } from '../../context/themeContext'
import './LogosSection.scss'

const LogosSection = ({ data }) => {
  const { title, summary, media } = data
  const { theme } = useTheme()

  const logoList = media.map((logo) => {
    return (
      <div className="logos__image" key={`logo-${logo.name}`}>
        <img
          src={
            theme === 'dark' && logo.imageDark
              ? logo.imageDark.url
              : logo.img.url
          }
          alt={logo.name}
        />
      </div>
    )
  })

  const CustomRightArrow = ({ onClick }) => {
    return (
      <div 
        className="custom-arrow custom-right-arrow"
        onClick={onClick}
        onKeyDown={(e) => e.key === 'Enter' && onClick(e)} 
        role="button"
        aria-label="Next slide"
        tabIndex={0}
      >
        <Icon type={'fa-solid'} code={'fa-angle-right'}/>
      </div>
    );
  };
  
  const CustomLeftArrow = ({ onClick }) => {
    return (
      <div 
        className="custom-arrow custom-left-arrow"
        onClick={onClick} 
        onKeyDown={(e) => e.key === 'Enter' && onClick(e)} 
        role="button"
        aria-label="Prev slide"
        tabIndex={0}
      >
        <Icon type={'fa-solid'} code={'fa-angle-left'}/>
      </div>
    );
  };

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 3
    },
    mobileTablet: {
      breakpoint: { max: 767, min: 577 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 576, min: 0 },
      items: 1
    }
  }

  return (
    <div
      className="logos container py-3 my-3"
      id={'logosSection-' + data.id}
    >
      {title && <h2 className="logos__title">{title}</h2>}
      {summary && <h6 className="logos__summary px-lg-3">{summary}</h6>}

      <Carousel
        responsive={responsive}
        autoPlay={logoList.length > 4}
        autoPlaySpeed={3000}
        infinite={logoList.length > 4}
        containerClass={'containerCarrusel'}
        customRightArrow={<CustomRightArrow />}
        customLeftArrow={<CustomLeftArrow />}
        removeArrowOnDeviceType={logoList.length <= 4 && ['tablet', 'desktop']}
      >
        {logoList}
      </Carousel>
    </div>
  )
}

export default LogosSection
